import { areArrsEqual, sort } from '@/helpers/helpers'
import { OFFER_TYPE } from '@/helpers/constants'

const offerTypeForProductPrices = offer => {
  if (offer.type === OFFER_TYPE.C) {
    return OFFER_TYPE.C
  }
  return offer.modifiedDiscounts ? OFFER_TYPE.B : OFFER_TYPE.A
}

export const areDefaultProductWeights = product => {
  const selectedWeights = sort([...product.currentWeightIdList])
  const standardWeights = sort([...product.standardWeightIdList])

  return areArrsEqual(selectedWeights, standardWeights)
}

const offerTypeForProductWeights = offer => {
  if (offer.type === OFFER_TYPE.C) {
    return OFFER_TYPE.C
  }
  return offer.modifiedWeights ? OFFER_TYPE.B : OFFER_TYPE.A
}

const offerTypeForAdditionalServices = offer => {
  return offer.modifiedServices ? OFFER_TYPE.B : OFFER_TYPE.A
}


const offerTypeForPaymentMethods = offer => {
  const MAX_DEBT_DAYS_FOR_OFFER_TYPE_A = 1
  const selectedPaymentMethod = offer.paymentMethods.find(method => method.isSelected)

  if (
    selectedPaymentMethod &&
    (
      selectedPaymentMethod.id === 'RECD' ||
      (selectedPaymentMethod.id === 'RECD30' && offer.additionalServices.paymentDay <= MAX_DEBT_DAYS_FOR_OFFER_TYPE_A) ||
      selectedPaymentMethod.id === 'DD' ||
      (selectedPaymentMethod.id === 'TRF30' && offer.additionalServices.paymentDay <= MAX_DEBT_DAYS_FOR_OFFER_TYPE_A) ||
      (selectedPaymentMethod.id === 'RMB30' && offer.additionalServices.paymentDay <= MAX_DEBT_DAYS_FOR_OFFER_TYPE_A) ||
      (selectedPaymentMethod.id === 'PAY30' && offer.additionalServices.paymentDay <= MAX_DEBT_DAYS_FOR_OFFER_TYPE_A)
    )
  ) {
    return OFFER_TYPE.A
  }
  return OFFER_TYPE.B
}


const offerTypeForProducts = offer => {
  if (offer.type === OFFER_TYPE.C) {
    return OFFER_TYPE.C
  }
  return offer.modifiedProducts ? OFFER_TYPE.B : OFFER_TYPE.A
}

// NOTE: before, each step was responsible for checking the offer type based on that step. and
// calling a mutation to store it in memory. Since this data was not being sent to the server and
// stored in database, this could lead to incorrect behavior when loading an edited offer. This is
// why now we reevaluate the offer type depending on these three steps although it implies to loop
// through products, additional services and payment methods at each check
export const calculateOfferTypeByValidations = offer => ({
  productPrices: offerTypeForProductPrices(offer),
  productWeights: offerTypeForProductWeights(offer),
  additionalServices: offerTypeForAdditionalServices(offer),
  paymentMethods: offerTypeForPaymentMethods(offer),
  products: offerTypeForProducts(offer),
})

const OFFER_TYPES_HIERARCHY = [OFFER_TYPE.A, OFFER_TYPE.B, OFFER_TYPE.C]

const getBiggerOfferType = (first, second) => {
  const firstIndex = OFFER_TYPES_HIERARCHY.indexOf(first)
  const secondIndex = OFFER_TYPES_HIERARCHY.indexOf(second)

  if (firstIndex === -1 && secondIndex === -1) {
    return first > second ? first : second
  }

  if (firstIndex === -1) {
    return first
  }

  if (secondIndex === -1) {
    return second
  }

  return firstIndex > secondIndex ? first : second
}

const minOfferTypeByRateModel = offer => offer.rateModel?.type ?? OFFER_TYPE.A

const offerTypeByOptyServicePoints = offer => {
  const servicePointsWithSeveralShipments = offer.optyServicePoints.filter(
    servicePoint => servicePoint.compromisedShipments > 0,
  )
  return servicePointsWithSeveralShipments.length > 1 ? OFFER_TYPE.B : OFFER_TYPE.A
}

export const getComputedOfferType = (offerTypeByValidations, offer) => {
  return Object.values(offerTypeByValidations)
    .concat(minOfferTypeByRateModel(offer))
    .concat(offerTypeByOptyServicePoints(offer))
    .reduce(getBiggerOfferType, OFFER_TYPE.A)
}
